<script lang="ts" setup>
import { computed } from 'vue'

import { Participant, TeamSide } from '@collector/sportsapi-client-legacy'
import { getTeamSide } from '@mobile/reusables/entityUtils'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'

import { useCricketCurrentBattersAndBowler } from '../../useCricketCurrentBattersAndBowler'

type Props = {
  batter?: boolean
  bowler?: boolean
  participant: Participant
}

const props = defineProps<Props>()

// computed
const participantTeamSide = computed(() =>
  getTeamSide(probableEvent.value.participants, props.participant.id),
)

// composables
const { probableEvent } = useEventInjections()
const {
  shouldRenderCurrentBatters: _shouldRenderCurrentBatters,
  currentMainBatter,
  currentBowler,
} = useCricketCurrentBattersAndBowler(participantTeamSide)

// computed
const shouldRenderCurrentBatters = computed(() =>
  _shouldRenderCurrentBatters(props.participant),
)
const currentBatterOrBowler = computed(() => {
  return shouldRenderCurrentBatters.value
    ? currentMainBatter.value
    : currentBowler.value
})
</script>

<template>
  <div class="block lg:hidden">
    <div class="text-xxs">
      {{ shouldRenderCurrentBatters ? 'CURRENT BATTER' : 'CURRENT BOWLER' }}
    </div>
    <div class="flex gap-2">
      <div class="text-xs font-bold">
        <div
          v-if="currentBatterOrBowler"
          :class="{
            'text-home': participantTeamSide === TeamSide.Home,
            'text-away': participantTeamSide === TeamSide.Away,
          }"
        >
          <div class="flex">
            <div v-if="currentBatterOrBowler.participant_shirt_number">
              {{ currentBatterOrBowler.participant_shirt_number }}
            </div>
            <div>{{ currentBatterOrBowler.participant_name }}</div>
          </div>
        </div>
        <div
          v-else
          class="opacity-30"
        >
          Not selected yet
        </div>
      </div>
    </div>
  </div>
</template>
